"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppShell = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("../styled-components"));
const GlobalStyle_1 = require("./GlobalStyle");
const Header_1 = require("./Header");
const Navigation_1 = require("./Navigation");
const __1 = require("..");
const i18next_1 = require("i18next");
const BodyWrapper = styled_components_1.default.div `
  height: 100%;
  width: 100%;
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  overflow: hidden;
`;
const Footer = styled_components_1.default.footer `
  position: absolute;
  bottom: 0;
  padding: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: hidden;
  background: ${({ theme, isBrowserSupported, isOperatingSystemNotSupported, }) => !isBrowserSupported || isOperatingSystemNotSupported
    ? theme.notification.warning.bg
    : theme.error};
  justify-content: center;
  align-items: center;
  column-gap: 5px;
`;
const FooterMessage = styled_components_1.default.div `
  font-size: 14px;
  color: ${({ theme }) => theme.fgInverted};
`;
const AppShell = ({ children, header, navigation, showBanner, showFooter, isBrowserSupported, isOperatingSystemNotSupported, showCloseButton, }) => {
    const theme = (0, styled_components_1.useTheme)();
    const [visibileFooter, setVisibleFooter] = react_1.default.useState(true);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(GlobalStyle_1.GlobalStyle, null),
        react_1.default.createElement(Header_1.Header, { ...header },
            react_1.default.createElement(Navigation_1.Navigation, { ...navigation, appType: header.logoType, showBanner: showBanner })),
        react_1.default.createElement(BodyWrapper, null, children),
        showFooter && visibileFooter && (react_1.default.createElement(Footer, { isBrowserSupported: isBrowserSupported, isOperatingSystemNotSupported: isOperatingSystemNotSupported },
            react_1.default.createElement(__1.Flex, { align: "center" },
                react_1.default.createElement(__1.Flex, { flex: "0 0 25px" }),
                react_1.default.createElement(__1.Flex, { align: "center", justify: "center", style: { flex: "0 0 1" } },
                    react_1.default.createElement(__1.AlertError, { fill: theme.fgInverted, size: 32 }),
                    react_1.default.createElement(FooterMessage, { style: { marginLeft: "10px" } }, isOperatingSystemNotSupported
                        ? (0, i18next_1.t)("message-footerOperatingSystemNotSupported")
                        : !isBrowserSupported
                            ? (0, i18next_1.t)("message-footerBrowserNotSupported")
                            : (0, i18next_1.t)("message-footer"))),
                react_1.default.createElement(__1.Flex, { flex: "0 0 25px", justify: "center" }, showCloseButton && (react_1.default.createElement(__1.CloseButton, { onClick: () => {
                        setVisibleFooter(!visibileFooter);
                    }, fill: theme.fgInverted }))))))));
};
exports.AppShell = AppShell;
//# sourceMappingURL=index.js.map